<div class="wrapper">
    <div class="container">
      <div class="participants">
        <app-int-participant
          [match]="match"
          [sideNumber]="1"
          [serverSideNumber]="match.score?.server?.sideNumber"
          [serverPlayerNumber]="match.score?.server?.playerNumber"
          [winningSide]="match.winningSide"
          [teamName]="tie?.sides[0]?.team?.abbreviation"
          [sideColor]="side1Color"
          [teamLogo]="teamLogoSide1"
          [profileImage]="teamProfileImageSide1"
          [setWinner]="match?.winningSide === 1"
        >
        </app-int-participant>
        <app-int-participant
          [match]="match"
          [sideNumber]="2"
          [serverSideNumber]="match.score?.server?.sideNumber"
          [serverPlayerNumber]="match.score?.server?.playerNumber"
          [winningSide]="match.winningSide"
          [teamName]="tie?.sides[1]?.team?.abbreviation"
          [sideColor]="side2Color"
          [teamLogo]="teamLogoSide2"
          [profileImage]="teamProfileImageSide2"
          [setWinner]="match?.winningSide === 2"
        >
        </app-int-participant>
      </div>

      @if(!summaryView){
          <div class="status">
            <app-int-status
              [winningSide]="match?.winningSide"
              [matchStatus]="match?.matchStatus"
              [serverSideNumber]="match?.score?.server?.sideNumber"
              [serverNumber]="match?.score?.server?.serverNumber"
              [returningSide]="match?.score?.server?.returningSide"
              [sideNumber]="1"
              [setWinner]="match?.winningSide === 1"
            ></app-int-status>
            <app-int-status
              [winningSide]="match?.winningSide"
              [matchStatus]="match?.matchStatus"
              [serverSideNumber]="match?.score?.server?.sideNumber"
              [serverNumber]="match?.score?.server?.serverNumber"
              [returningSide]="match?.score?.server?.returningSide"
              [sideNumber]="2"
              [setWinner]="match?.winningSide === 2"
            ></app-int-status>
          </div>
        }
      @if (match.score?.sets?.length && summaryView) { 
            @for (set of match.score.sets; track $index) {
                <div class="games">
                    <app-int-game
                      [gameScore]="set.side1Score"
                      [tiebreakScore]="set.side1TiebreakScore"
                      [setWinner]="match?.winningSide === 1"
                      [setWinnerColor]="side1Color"
                      [matchStatus]="match?.matchStatus"
                      [summaryView]="summaryView"
                    ></app-int-game>
                    <app-int-game
                      [gameScore]="set.side2Score"
                      [tiebreakScore]="set.side2TiebreakScore"
                      [setWinner]="match?.winningSide === 2"
                      [setWinnerColor]="side2Color"
                      [matchStatus]="match?.matchStatus"
                      [summaryView]="summaryView"
                    ></app-int-game>
                  </div>
            }
       }

      <div class="points">
        <app-int-point
          [pointScore]="match?.score?.side1PointScore"
          [summaryView]="summaryView"
        ></app-int-point>
        <app-int-point
          [pointScore]="match?.score?.side2PointScore"
          [summaryView]="summaryView"
        ></app-int-point>
      </div>
    </div>
</div>